import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import {
  ModalArchiveDrsFile,
  ModalArchiveDrsFileProps,
} from "components/ModalArchiveDrsFile/ModalArchiveDrsFile";
import { useState } from "react";
import { getDrsFileModifyPermissionByDrsFileAndAction } from "types/DrsFileModifyPermissions";

export interface ButtonArchiveDrsFileProps {
  drsFile: Parameters<typeof getDrsFileModifyPermissionByDrsFileAndAction>[0] &
    ModalArchiveDrsFileProps["drsFiles"][number];
}

export const ButtonArchiveDrsFile = ({
  drsFile,
}: ButtonArchiveDrsFileProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  return (
    <>
      <ButtonIconPermissioned
        aria-label="Archive file"
        defaultTooltip={"Archive file"}
        color="primary"
        iconType="snowflake"
        isDisabled={
          !getDrsFileModifyPermissionByDrsFileAndAction(drsFile, "ARCHIVE")
            .isPermitted
        }
        onClick={() => {
          setShowConfirmModal(true);
        }}
        requiredPermission="edit"
      />
      {showConfirmModal && (
        <ModalArchiveDrsFile
          drsFiles={[drsFile]}
          onClose={() => setShowConfirmModal(false)}
        />
      )}
    </>
  );
};
